import { Component } from "react";
import { connect } from "react-redux";
import Auxiliary from "util/Auxiliary";
import Avatar from "components/Avatar";
import { injectIntl } from 'react-intl';
import MenuAdmin from '../Menus/MenuAdmin';
import MenuUser from '../Menus/MenuUser';
import MenuComedien from '../Menus/MenuComedien';
import AlgoliaFilter from '../Menus/AlgoliaFilter';
import CustomScrollbars from "util/CustomScrollbars";

import {
  USER_ROLE_COMEDIEN,
  USER_ROLE_UTILISATEUR,
  USER_ROLE_ADMIN,
} from "constants/General";

import noAvatar from "assets/images/no-avatar.webp";
import { APPLICATION_PATHS } from "constants/ApplicationPaths";
import { withRouter } from "util/withRouter";

class SidebarContent extends Component {
  constructor() {
    super();
  }

  renderMenus() {
    const { currentUser } = this.props;

    if (!currentUser) {
      return null;
    }

    let userAvatar = ""

    if (currentUser.photo && (currentUser.photo !== '')) {
      userAvatar = currentUser.photo;
    } else {
      userAvatar = noAvatar;
    }

    return (
      <Auxiliary>
        <div className="cm-sidebar-menu-content">

          <div className="cm-sider-avatar">
            <Avatar
              src={userAvatar}
              width="96px"
              height="96px"
            />
          </div>

          <div className="cm-sider-user-name">
            {currentUser.prenom + ' ' + currentUser.nom}
          </div>

          <CustomScrollbars className="gx-layout-sider-scrollbar">

            {(() => {
              if (currentUser.typeCompte === USER_ROLE_ADMIN) {
                return (
                  <MenuAdmin />
                )
              } else if (currentUser.typeCompte === USER_ROLE_UTILISATEUR) {
                return (
                  <MenuUser />
                )
              } else if (currentUser.typeCompte === USER_ROLE_COMEDIEN) {
                return (
                  <MenuComedien />
                )
              } else {
                return (
                  null
                )
              }
            })()}

          </CustomScrollbars>

        </div>
      </Auxiliary>
    );
  }

  render() {

    if (window.location.pathname === APPLICATION_PATHS.RECHERCHE) {
      return (<AlgoliaFilter />);
    } else if (this.props.page === 'ficheComedienUrl') {
      return (<AlgoliaFilter />);
    } else {
      return (this.renderMenus());
    }
  }
}

SidebarContent.propTypes = {};

const mapStateToProps = ({ auth }) => {
  const {
    currentUser
  } = auth;

  return {
    currentUser
  }
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      {
      }
    )(SidebarContent)
  )
);